import React, {Component} from 'react';
import "../../../css/pages/admin/RoomRatesEditor.css"
import Card from "@material-ui/core/Card/Card";
import Button from "@material-ui/core/Button/Button";
import {Get} from "../../api/client/Get";
import {PutWithAuth} from "../../api/client/Put";

class RoomRatesEditor extends Component {

    constructor(props) {
        super(props);

        this.state = {
            rates: [],
            unsaved: false
        };

        Get("/api/rates")
            .then((res) => {
                this.setState({
                    rates: res.data
                })
            });
    }

    handleChange = (e, cur, id) => {
        e.preventDefault();
        let newRates = [];
        this.state.rates.forEach((r) => {
            if (r.roomId === id) {
                let val = parseInt(e.target.value);
                if (cur === "GBP") {
                    r.rateGBP = val;
                } else {
                    r.rateEuros = val;
                }
            }
            newRates.push(r);
        });

        this.setState({
            rates: newRates,
            unsaved: true
        });
    };

    save = () => {
        if (this.state.unsaved) {
            PutWithAuth("/api/rates", this.props.token, this.state.rates)
                .then(res => {
                    if (res.data !== "Success") {
                        alert("Something went wrong!\nPlease contact the developer.\nError: " + res);
                    } else {
                        this.setState({
                            unsaved: false
                        });
                    }
            });
        }
    };

    render() {
        return (
            <div id={"rates_wrapper"}>
                <h1 style={{width: "100%"}}>Room Rates Editor</h1>
                {
                    this.state.rates.slice(0,3).map(r => this.renderSingleRateEditor(r))
                }
                <br/>
                {
                    this.state.rates.slice(3,6).map(r => this.renderSingleRateEditor(r))
                }
                <br/>
                <div style={{width: "100%"}}>
                    <Button variant="outlined" color="primary"
                            onClick={e => this.save()}>
                        SAVE
                    </Button>
                    {
                        this.state.unsaved ? <p>Unsaved changes!</p> : ""
                    }
                </div>
            </div>
        );
    }

    renderSingleRateEditor(r) {
        return (
            <Card className={"room_rate"} key={"room-rate-" + r.roomId}>
                <h3>Room {r.roomId}</h3>
                <table>
                    <thead>
                    <tr>
                        <td>
                            £
                        </td>
                        <td>
                            €
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <input type={"number"} value={r.rateGBP}
                                   onChange={e => this.handleChange(e, "GBP", r.roomId)}/>
                        </td>
                        <td>
                            <input type={"number"} value={r.rateEuros}
                            onChange={e => this.handleChange(e, "EUR", r.roomId)}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Card>

        );
    }
}

export default RoomRatesEditor;
